<div class="g-0">
    <div class="col">
        <div class="box-wrapper">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-circle-info"></i>
                                <span class="ms-2">Conținut Proiect</span>
                            </div>
                            <button
                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                class="btn btn-small btn-primary edit-btn" (click)="toggleEditField()">
                                <i class="fa fa-pencil" *ngIf="!showEditField"></i>
                                <i class="fa fa-close" *ngIf="showEditField"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <ng-container *ngIf="!showEditField">
                    <div class="row py-1 mx-1 bg">
                        <div class="col-6">
                            <div class="fw-bold">Locație</div>
                        </div>
                        <div class="col-3">
                            <div class="fw-bold">Dată început</div>
                        </div>
                        <div class="col-3">
                            <div class="fw-bold">Dată finalizare</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col-6">
                            <div class="">{{ proiect.locatie }}</div>
                        </div>
                        <div class="col-3">
                            <div class="">{{ proiect.data_inceput_reala }}</div>
                        </div>
                        <div class="col-3">
                            <div class="">{{ proiect.data_finalizare_reala }}</div>
                        </div>
                    </div>

                    <div class="row py-1 mx-1 bg">
                        <div class="col">
                            <div class="fw-bold">Observații</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col">
                            <div [innerHTML]="proiect.description || 'n/a'"></div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="showEditField">
                    <form class="p-1" [formGroup]="form" (submit)="submitForm()">
                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Dată început</mat-label>
                                    <input matInput [matDatepicker]="pickerInceput" formControlName="dt_inceput"
                                        readonly (focus)="pickerInceput.open()" />
                                    <mat-datepicker-toggle matIconSuffix [for]="pickerInceput"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerInceput></mat-datepicker>
                                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                                    <mat-error
                                        *ngIf="!form.controls['dt_inceput'].valid && form.controls['dt_inceput'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Dată șfârșit</mat-label>
                                    <input matInput [matDatepicker]="pickerSfarsit" formControlName="dt_finalizare"
                                        readonly (focus)="pickerSfarsit.open()" />
                                    <mat-datepicker-toggle matIconSuffix [for]="pickerSfarsit"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerSfarsit></mat-datepicker>
                                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                                    <mat-error
                                        *ngIf="!form.controls['dt_finalizare'].valid && form.controls['dt_finalizare'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Motiv delay/actualizare?</mat-label>
                                    <mat-select formControlName="motiv_delay">
                                        <mat-option *ngFor="let row of motive" [value]="row.id">
                                            {{ row.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['motiv_delay'].valid && form.controls['motiv_delay'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <mat-error *ngIf="form.hasError('dateRange')">Data de sfârșit nu poate fi mai mică decât
                                    data de început</mat-error>
                            </div>
                        </div>

                        <div class="row" *ngIf="form.get('motiv_delay')?.value === 0">
                            <div class="col">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Observații motiv actualizare/delay? </mat-label>
                                    <textarea matInput formControlName="motiv_obs" name="motiv_obs"></textarea>
                                    <mat-hint>Completați motivul</mat-hint>
                                </mat-form-field>
                                <mat-error *ngIf="form.hasError('conditionalRequired')">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="fw-bold p-1">Observații</div>
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="observatii" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col d-flex justify-content-between">
                                <button type="button" class="btn btn-small btn-warning" (click)="closeEditField()">
                                    Închide
                                </button>
                                <button type="submit" class="btn btn-small btn-primary" [disabled]="form.invalid">
                                    Salvează
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>